import React from "react";
import { BRAND_LOGO_URL, useBrand } from "@/lib/brand";

/**
 * Central brand config for the customer portal. Edit these to match your identity.
 * (Support email/phone appear in the header help + footer + login page.)
 */
export const BRAND = {
  name: "FIDEL GROUP",
  tagline: "Precision in logistics, excellence in service",
  logo: "/logos/fidel-group.png",       // fallback bundled with the app
  supportEmail: "support@fidellogistics.in",
  supportPhone: "+91 265 000 0000",
  website: "https://fidellogistics.in",
  address: "Vadodara, Gujarat, India",
};

// Logo for the current domain's brand, served from a same-origin URL (CSP-safe).
// Falls back to the bundled logo, then a text mark using the brand's name.
export { useBrand } from "@/lib/brand";

export function PortalLogo({ className = "h-9 w-auto object-contain", fallbackClass = "" }) {
  const brand = useBrand();
  const [stage, setStage] = React.useState(0); // 0 = brand logo, 1 = bundled, 2 = text
  const name = brand?.name || BRAND.name;
  // Same precedence as the public site: brand.logo_url first, then the
  // logo_data endpoint, then the bundled default, then a text mark.
  const brandLogo = brand?.logo_url || BRAND_LOGO_URL;
  // useBrand() resolves asynchronously, so the first render can fail over to the
  // bundled logo before the real one arrives — re-arm when the URL changes.
  React.useEffect(() => { setStage(0); }, [brandLogo]);
  if (stage >= 2) {
    return <span className={`font-extrabold tracking-tight text-slate-900 ${fallbackClass}`}>{name}</span>;
  }
  const src = stage === 0 ? brandLogo : BRAND.logo;
  return <img src={src} alt={name} onError={() => setStage((s) => s + 1)} className={className} />;
}
